export default __webpack_public_path__ + "static/media/logo-nvb.e88fbec0.svg";